import React, { useRef } from "react";
import {
  ButtonBase,
  ThemeProvider,
  theme,
  FileUploaderBase,
  LabelBase,
} from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";
import { uploadFile, createBulkUpload } from "services";
import Loader from "../../layouts/Loader";

const newTheme = {
  ...theme,
  variants: {},
};

export default function UploadModal(props: any) {
  const fileUploadRef = useRef<any>(null);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [afterUploadedFiles, setAfterUploadedFiles] = React.useState<any>([]);
  const [selectedFiles, setSelectedFiles] = React.useState<any>([]);

  const OpenFileUploader = (props: any) => {
    return (
      <div className="mt-2 grid grid-cols-1 grid-flow-col gap-4">
        <div className="bg-gray-50 py-2 px-2 border">
          <div className="flex justify-between items-center border-b pb-4">
            <LabelBase label={"Upload File"} />
            <ButtonBase
              type="button"
              label="Select File"
              onClick={() => {
                props.triggerClickHandler();
              }}
            />
          </div>

          <div className="mt-4">
            {props.selectedFiles.length > 0 && (
              <div>
                {props.selectedFiles.map((file: any, index: number) => {
                  return <div key={index}>{file.file.name}</div>;
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <ThemeProvider value={newTheme}>
      <div className="relative shadow-sm flex flex-col">
        <div className="flex-1">
          <div
            className={
              "absolute z-50 -top-4 -right-4 rounded-full bg-gray-50 items-center px-2 py-2 border-b text-xs text-gray-900"
            }
          >
            <div
              className="cursor-pointer"
              onClick={() => props.onAction("no")}
            >
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </div>
          </div>
          <div className={"relative border-b " + props.color}>
            <div className="px-4 lg:px-8">
              <div className="relative py-6 text-center">
                <h2 className="text-xl font-semibold tracking-tight">
                  {props.heading}
                </h2>
              </div>
            </div>
          </div>
          <div className="p-4 w-2xl">
            <div className="mt-2 min-h-max text-center text-base text-gray-500">
              {props.description}
            </div>

            <div className="mt-2 space-y-4 w-full">
              <div>
                <div className="mt-1">
                  <FileUploaderBase
                    ref={fileUploadRef}
                    multiple={false}
                    autoUpload={false}
                    selectedFiles={(selectedFiles) => {
                      setSelectedFiles(selectedFiles);
                    }}
                    upload={async (selectedFile) => {
                      console.log("selectedFile: upload called", selectedFile);
                      const createData: any = await createBulkUpload({
                        name: selectedFile.name,
                      });
                      return await uploadFile(selectedFile, {
                        owner_service: "bulk-upload",
                        owner_identifier: createData.uuid,
                      });
                    }}
                    beforeUpload={(uploadedFiles) => {
                      console.log("beforeUpload", uploadedFiles);
                    }}
                    afterUpload={async (uploadedFiles) => {
                      setSelectedFiles([]);
                      console.log("uploaded File:", uploadedFiles[0]);
                      props.onAction("no");
                      props.callback();
                      setLoading(false);
                    }}
                    openFileUploader={(triggerClickHandler) => (
                      <OpenFileUploader
                        selectedFiles={selectedFiles}
                        afterUploadedFiles={afterUploadedFiles}
                        triggerClickHandler={triggerClickHandler}
                        fileUploadRef={fileUploadRef}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center py-4 border-t">
            <ButtonBase
              variant="primary"
              type="button"
              label="Upload"
              onClick={async () => {
                setLoading(true);
                fileUploadRef?.current?.triggerUpload();
              }}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                padding: "px-8 py-3",
              }}
              busy={loading}
              busyText={<Loader height="h-6" width="w-6" />}
            />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
